import {Injectable} from '@angular/core';
import {RestaurantRepository} from "../repositories/restaurant.repository";
import {FilterService} from "./filterer/filter.service";
import {DataManipulationService} from "./data-manipulation.service";
import {MyStorageService} from "./my-storage.service";


@Injectable({
    providedIn: 'root'
})
export class RestaurantService {

    private REST_KEY = 'users_restaurants';
    typeName: any;

    constructor(private repo: RestaurantRepository,
                private filterService: FilterService,
                private dataManipulationService: DataManipulationService,
                private myStorageService: MyStorageService) {
        this.typeName = 'Restaurant';
    }


    getAllForUser() {
        return this.repo.getAllForUser();
    }

    async storeUsersRestaurants() {
        let restaurants = await this.getAllForUser().toPromise();
        this.myStorageService.saveToCookies(this.REST_KEY, JSON.stringify(restaurants));
    }

    getUsersRestaurants() {
        return JSON.parse(this.myStorageService.getFromCookies(this.REST_KEY, 'null'));
    }

    addExtraDataForOne(restaurant: any): any {
        this.dataManipulationService.addNameToElement(restaurant);
        return restaurant
    }
}
